import { motion } from "framer-motion";
import { OOL_PHOTOS } from "../config/photos";

// 2x2 personal photo grid for /about. Each card has its own accent glow
// (cyan / violet / rose / amber) and an editorial caption.
const ACCENTS = [
    { ring: "ring-cyan-400/35 hover:ring-cyan-300/70", glow: "rgba(34,211,238,0.45)" },
    { ring: "ring-violet-400/35 hover:ring-violet-300/70", glow: "rgba(196,160,255,0.45)" },
    { ring: "ring-rose-400/35 hover:ring-rose-300/70", glow: "rgba(251,113,133,0.45)" },
    { ring: "ring-amber-400/35 hover:ring-amber-300/70", glow: "rgba(251,191,36,0.45)" },
];

export const PhotoStrip = () => {
    return (
        <section className="relative py-10 lg:py-14" data-testid="about-photo-strip">
            <div className="max-w-5xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="mb-8"
                >
                    <span className="eyebrow">In the wild</span>
                    <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">
                        Off-stream <span className="gradient-text">snapshots</span>
                    </h2>
                    <p className="text-white/55 mt-2 max-w-xl text-sm">
                        A few moments off the broadcast: chair, cockpit, and everywhere in between.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
                    {OOL_PHOTOS.map((p, i) => {
                        const a = ACCENTS[i % ACCENTS.length];
                        return (
                            <motion.figure
                                key={p.id}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: i * 0.07 }}
                                className={`relative overflow-hidden rounded-2xl border border-white/10 bg-obsidian-900 ring-1 ${a.ring} transition group`}
                                style={{ boxShadow: `0 0 0 transparent` }}
                                data-testid={`about-photo-${i}`}
                            >
                                <div className="aspect-[4/5] sm:aspect-[3/4] w-full bg-black">
                                    <img
                                        src={p.src}
                                        alt={p.alt}
                                        loading="lazy"
                                        className="w-full h-full object-cover transition duration-700 group-hover:scale-[1.04]"
                                    />
                                </div>
                                <div
                                    aria-hidden
                                    className="absolute inset-x-0 bottom-0 h-2/5 pointer-events-none"
                                    style={{
                                        background: `linear-gradient(to top, rgba(0,0,0,0.85), transparent)`,
                                    }}
                                />
                                <figcaption className="absolute bottom-4 left-5 right-5 flex items-end justify-between">
                                    <div>
                                        <span className="font-display text-white text-lg leading-tight drop-shadow">
                                            {p.caption}
                                        </span>
                                    </div>
                                    <span
                                        className="font-mono text-[10px] uppercase tracking-[0.25em]"
                                        style={{ color: a.glow.replace("0.45", "0.95").replace("rgba", "rgb").replace(/,([^,]+)\)$/, ")") }}
                                    >
                                        0{i + 1}
                                    </span>
                                </figcaption>
                            </motion.figure>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
